/**
* Testimonials Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Testimonials Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'testimonials-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.testimonials-marquee__top-splide' ).length > 0 && $( '.testimonials-marquee__bottom-splide' ).length > 0 ) {
        $( '.testimonials-marquee' ).each( function( index, element ) {
          const topSlider = new Splide( $( this ).find( '.testimonials-marquee__top-splide' )[0], {
            type: 'loop',
            gap: '48px',
            perPage: 4,
            pagination: false,
            autoWidth: true,
            // autoHeight: true,
            arrows: false,
            autoScroll: {
              speed: 1,
              pauseOnHover: false,
            },
            breakpoints: {
              1024: {
                perPage: 3,
              },
              768: {
                perPage: 2,
              },
            },
          } );
          const bottomSlider = new Splide( $( this ).find( '.testimonials-marquee__bottom-splide' )[0], {
            type: 'loop',
            gap: '48px',
            perPage: 4,
            pagination: false,
            arrows: false,
            autoWidth: true,
            // autoHeight: true,
            autoScroll: {
              speed: -1,
              pauseOnHover: false,
            },
            breakpoints: {
              1024: {
                perPage: 3,
              },
              768: {
                perPage: 2,
              },
            },
          } );
          topSlider.mount( {AutoScroll} );
          bottomSlider.mount( {AutoScroll} );

          $( this ).find( '.testimonials-marquee__top-splide' ).on( 'mouseover', function() {
            topSlider.Components.AutoScroll.pause();
          } );
          $( this ).find( '.testimonials-marquee__top-splide' ).on( 'mouseout', function() {
            topSlider.Components.AutoScroll.play();
          } );
          $( this ).find( '.testimonials-marquee__bottom-splide' ).on( 'mouseover', function() {
            bottomSlider.Components.AutoScroll.pause();
          } );
          $( this ).find( '.testimonials-marquee__bottom-splide' ).on( 'mouseout', function() {
            bottomSlider.Components.AutoScroll.play();
          } );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'testimonials-marquee', COMPONENT );
} )( app );
